import { render } from "./ManageListInventory.vue?vue&type=template&id=bc52303a&scoped=true"
import script from "./ManageListInventory.vue?vue&type=script&lang=js"
export * from "./ManageListInventory.vue?vue&type=script&lang=js"

import "./ManageListInventory.vue?vue&type=style&index=0&id=bc52303a&scoped=true&lang=css"
import "./ManageListInventory.vue?vue&type=style&index=1&id=bc52303a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc52303a"]])

export default __exports__